<div class="main">
    <div class="container">
        <h2> {{isSIP ? 'SIP' : 'Quỹ'}} {{product?.code}}</h2>
        <nz-tabset (nzSelectChange)="selectTab($event)">
            <nz-tab nzTitle="Phí phát hành">
            </nz-tab>

            <nz-tab nzTitle="Phí bán">
            </nz-tab>

            <nz-tab nzTitle="Phí chuyển đổi">
            </nz-tab>

        </nz-tabset>

        <!-- Phí phát hành -->
        <div class="row" [hidden]="tab !== TABS.BUY_FEE">
            <app-new-buy-fee-fund [relationalOperators]="resource.relationalOperators"
                [fees]="feeBuys" [currentFees]="currentFeeBuys" [startDate]="startDateBuyFee">
            </app-new-buy-fee-fund>
        </div>

        <!-- Phí bán -->
        <div class="row" [hidden]="tab !== TABS.SELL_FEE">
            <app-new-sell-fee-fund [relationalOperators]="resource.relationalOperators"
                [fees]="feeSells" [currentFees]="currentFeeSells" [startDate]="startDateSellFee">
            </app-new-sell-fee-fund>
        </div>


         <!-- Phí chuyển đổi -->
         <div class="row" [hidden]="tab !== TABS.TRANSFER_FEE">
            <app-new-transfer-fee-fund [relationalOperators]="resource.relationalOperators" [product]="product"
                [fees]="feeTransferTemp" [currentFees]="currentFeeSells" [startDate]="startDateTransferFee">
            </app-new-transfer-fee-fund>
        </div>

    </div>
</div>